<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <!-- Navbar -->
    <HeaderMenu />
    <!-- End Navbar -->
    <main class="main-content position-relative border-radius-lg">
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <div class="row">
          <div class="col-12">
            <div class="card mb-4">
              <div class="card-header pb-0">
                <div class="d-flex align-items-center gap-2">
                  <i class="fas fa-chart-line text-primary"></i>
                  <h5 class="mb-0">Cuadro de mando</h5>
                </div>
              </div>

              <div class="card-body">
                <div class="row g-3">
                  <!-- Calendario (col-8) -->
                  <div class="col-12 col-lg-8">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <div>
                        <div class="text-muted small">Calendario</div>
                        <div class="fw-bold">{{ tituloMes }}</div>
                      </div>

                      <div class="d-flex gap-2">
                        <button type="button" class="btn btn-sm btn-outline-primary" @click="mesAnterior">
                          <i class="fas fa-chevron-left"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-primary" @click="mesSiguiente">
                          <i class="fas fa-chevron-right"></i>
                        </button>
                      </div>
                    </div>

                    <div ref="calendarWrapRef" class="calendar-wrap card">
                      <div class="calendar-header row g-0 text-center border-bottom">
                        <div v-for="d in diasSemana" :key="d" class="col calendar-dow py-2 text-muted small">
                          {{ d }}
                        </div>
                      </div>

                      <div class="calendar-grid">
                        <div
                          v-for="cell in calendarCells"
                          :key="cell.key"
                          class="calendar-cell"
                          :class="{ 'is-out-month': !cell.inMonth }"
                        >
                          <div class="calendar-day">
                            <div class="day-number">{{ cell.day }}</div>
                            <div class="day-indicators">
                              <span
                                v-if="cell.subidos > 0"
                                class="indicator-pill indicator-blue"
                                :title="`Nuevos: ${cell.subidos}`"
                              >
                              Nuevos: {{ cell.subidos }}
                              </span>
                              <span
                                v-if="cell.aprobados > 0"
                                class="indicator-pill indicator-green"
                                :title="`Aprobados: ${cell.aprobados}`"
                              >
                              Aprobados: {{ cell.aprobados }}
                              </span>
                              <span
                                v-if="cell.caducados > 0"
                                class="indicator-pill indicator-red"
                                :title="`Caducados: ${cell.caducados}`"
                              >
                              Caducados: {{ cell.caducados }}
                              </span>
                              <span
                                v-if="cell.rechazados > 0"
                                class="indicator-pill indicator-purple"
                                :title="`Rechazados: ${cell.rechazados}`"
                              >
                              Rechazados: {{ cell.rechazados }}
                              </span>
                            </div>
                          </div>
                          <div class="future-indicators" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- KPIs (col-4) -->
                  <div class="col-12 col-lg-4">
                    <div ref="kpiStackRef" class="d-flex flex-column gap-3 kpi-stack" :style="kpiStackStyle">
                      <div class="kpi-card card h-100">
                        <div class="card-body">
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <div class="text-muted small">Documentos nuevos</div>
                            <div class="kpi-badge kpi-blue">Nuevos</div>
                          </div>
                          <div class="kpi-value">{{ totalSubidos.toLocaleString('es-ES') }}</div>
                          <div class="kpi-chart-area">
                            <canvas ref="chartSubidosRef" class="kpi-sparkline"></canvas>
                          </div>
                        </div>
                      </div>

                      <div class="kpi-card card h-100">
                        <div class="card-body">
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <div class="text-muted small">Documentos rechazados</div>
                            <div class="kpi-badge kpi-purple">{{ kpiVariacion.rechazados }}%</div>
                          </div>
                          <div class="kpi-value">{{ totalRechazados.toLocaleString('es-ES') }}</div>
                          <div class="kpi-chart-area">
                            <canvas ref="chartRechazadosRef" class="kpi-sparkline"></canvas>
                          </div>
                        </div>
                      </div>

                      <div class="kpi-card card h-100">
                        <div class="card-body">
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <div class="text-muted small">Documentos aprobados</div>
                            <div class="kpi-badge kpi-green">{{ kpiVariacion.aprobados }}%</div>
                          </div>
                          <div class="kpi-value">{{ totalAprobados.toLocaleString('es-ES') }}</div>
                          <div class="kpi-chart-area">
                            <canvas ref="chartAprobadosRef" class="kpi-sparkline"></canvas>
                          </div>
                        </div>
                      </div>

                      <div class="kpi-card card h-100">
                        <div class="card-body">
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <div class="text-muted small">Documentos caducados</div>
                            <div class="kpi-badge kpi-caducados">{{ kpiVariacion.caducados }}%</div>
                          </div>
                          <div class="kpi-value">{{ totalCaducados.toLocaleString('es-ES') }}</div>
                          <div class="kpi-chart-area">
                            <canvas ref="chartCaducadosRef" class="kpi-sparkline"></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Secciones analíticas -->
                <div class="mt-4">
                  <div class="nav nav-pills mb-3" style="gap: 10px;">
                    <button type="button" class="btn btn-outline-primary"
                      :class="{ active: dashboardTab === 'rendimiento' }"
                      @click="dashboardTab = 'rendimiento'">Rendimiento</button>
                    <button type="button" class="btn btn-outline-primary"
                      :class="{ active: dashboardTab === 'cuellos' }"
                      @click="dashboardTab = 'cuellos'">Cuellos de botella</button>
                    <button type="button" class="btn btn-outline-primary"
                      :class="{ active: dashboardTab === 'comportamiento' }"
                      @click="dashboardTab = 'comportamiento'">Comportamiento</button>
                  </div>

                  <!-- Rendimiento -->
                  <div v-show="dashboardTab === 'rendimiento'" class="rendimiento-tab">
                    <div class="row g-3">
                      <div class="col-12 col-lg-6">
                        <div class="card">
                          <div class="card-header py-2">
                            Tiempo medio de aprobación por esquema
                          </div>
                          <div class="card-body">
                            <canvas ref="chartPerfEsquemasRef"></canvas>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="card">
                          <div class="card-header py-2">
                            Tiempo medio de aprobación por usuario
                          </div>
                          <div class="card-body">
                            <canvas ref="chartPerfUsuariosRef"></canvas>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="card">
                          <div class="card-header py-2">
                            Tiempo medio de aprobación por: <strong>{{ propiedadAgrupadoraNombre || 'departamento' }}</strong>
                          </div>
                          <div class="card-body">
                            <canvas ref="chartPerfDeptosRef"></canvas>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="card">
                          <div class="card-header py-2">
                            Evolución en el tiempo
                          </div>
                          <div class="card-body">
                            <canvas ref="chartPerfEvolucionRef"></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Cuellos de botella -->
                  <div v-show="dashboardTab === 'cuellos'" class="cuellos-tab">
                    <div class="row g-3">
                      <div class="col-12 col-lg-6">
                        <div class="card">
                          <div class="card-header py-2">
                            Usuarios más lentos 
                          </div>
                          <div class="card-body">
                            <canvas ref="chartCuellosUsuariosRef"></canvas>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="card">
                          <div class="card-header py-2">
                            Acumulación por edad del pendiente 
                          </div>
                          <div class="card-body">
                            <canvas ref="chartCuellosEdadRef"></canvas>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="card">
                          <div class="card-header py-2">
                            Retrasos recurrentes 
                          </div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-sm mb-0">
                                <thead>
                                  <tr>
                                    <th>Esquema</th>
                                    <th>Usuario</th>
                                    <th class="text-end">Contador</th>
                                    <th class="text-end">Media (dias)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="row in mockRetrasosRecurrentes" :key="row.esquema_id">
                                    <td>{{ row.esquema_nombre }}</td>
                                    <td>{{ row.usuario_nombre }}</td>
                                    <td class="text-end">{{ row.count }}</td>
                                    <td class="text-end">{{ row.avg_seconds }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Comportamiento -->
                  <div v-show="dashboardTab === 'comportamiento'" class="comportamiento-tab">
                    <div class="row g-3">
                      <div class="col-12 col-lg-6">
                        <div class="card">
                          <div class="card-header py-2">
                            % Aprobaciones automáticas vs manuales 
                          </div>
                          <div class="card-body">
                            <canvas ref="chartComportAutoRef"></canvas>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="card">
                          <div class="card-header py-2">
                            % Rechazos por motivo 
                          </div>
                          <div class="card-body">
                            <canvas ref="chartComportRechazosRef"></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import Chart from "chart.js/auto";
import axiosInstance from "../axios.js";

const diasSemana = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

export default {
  name: "CuadroMandoView",
  components: { HeaderMenu },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(), // 0-11
      porDia: [],
      useMock: false,

      chartSubidos: null,
      chartAprobados: null,
      chartCaducados: null,
      chartRechazados: null,

      // Analítica 
      dashboardTab: "rendimiento",
      rangePreset: 30,
      esquemaFiltro: "",
      propiedadAgrupadoraNombre: "departamento",

      chartPerfEsquemas: null,
      chartPerfUsuarios: null,
      chartPerfDeptos: null,
      chartPerfEvolucion: null,
      chartCuellosUsuarios: null,
      chartCuellosEdad: null,
      chartComportAuto: null,
      chartComportRechazos: null,

      mockRetrasosRecurrentes: [],
      kpiStackHeight: null
    };
  },
  computed: {
    diasSemana() {
      return diasSemana;
    },
    tituloMes() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ];
      return `${meses[this.currentMonth]} ${this.currentYear}`;
    },
    totalSubidos() {
      return (this.porDia || []).reduce((acc, d) => acc + (d.subidos || 0), 0);
    },
    totalAprobados() {
      return (this.porDia || []).reduce((acc, d) => acc + (d.aprobados || 0), 0);
    },
    totalRechazados() {
      return (this.porDia || []).reduce((acc, d) => acc + (d.rechazados || 0), 0);
    },
    totalCaducados() {
      return (this.porDia || []).reduce((acc, d) => acc + (d.caducados || 0), 0);
    },
    kpiVariacion() {
      // Variación mock para el badge (desviación sobre el reparto ~33%).
      const total = Math.max(1, this.totalAprobados + this.totalCaducados + this.totalRechazados);
      const delta = (x) => Math.round(((x / total) - (1 / 3)) * 100 * 3);
      return {
        aprobados: delta(this.totalAprobados),
        caducados: delta(this.totalCaducados),
        rechazados: delta(this.totalRechazados)
      };
    },
    calendarCells() {
      const first = new Date(this.currentYear, this.currentMonth, 1);
      const last = new Date(this.currentYear, this.currentMonth + 1, 0);

      // Convertir JS getDay (0 Dom..6 Sáb) a Lunes=0..Dom=6
      const jsDay = first.getDay();
      const dowMonday0 = (jsDay + 6) % 7;

      const totalDaysInMonth = last.getDate();
      const totalCells = 42; // 6 semanas

      const cells = [];
      for (let i = 0; i < totalCells; i++) {
        const dayNumber = i - dowMonday0 + 1;
        const inMonth = dayNumber >= 1 && dayNumber <= totalDaysInMonth;
        const day = inMonth ? dayNumber : '';
        const item = inMonth ? (this.porDia || []).find(d => d.day === dayNumber) || {} : {};

        cells.push({
          key: `${this.currentYear}-${this.currentMonth}-${i}`,
          inMonth,
          day,
          subidos: item.subidos || 0,
          aprobados: item.aprobados || 0,
          caducados: item.caducados || 0,
          rechazados: item.rechazados || 0
        });
      }
      return cells;
    },
    kpiStackStyle() {
      if (!this.kpiStackHeight) return {};
      return { height: `${this.kpiStackHeight}px` };
    }
  },
  async mounted() {
    await this.cargarDatosMes();
    this.dibujarCharts();
    await this.cargarAnalitica();
    this.syncKpiHeightWithCalendar();
    window.addEventListener("resize", this.syncKpiHeightWithCalendar);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.syncKpiHeightWithCalendar);
  },
  watch: {
    dashboardTab() {
      // Al cambiar de pestaña, solo se redibuja lo que toca.
      this.dibujarChartsAnalitica();
    }
  },
  methods: {
    round1(value) {
      const n = Number(value);
      if (!Number.isFinite(n)) return 0;
      return Math.round(n * 10) / 10;
    },
    async cargarDatosMes() {
      if (this.useMock) {
        this.porDia = this.generarDatosMock(this.currentYear, this.currentMonth);
        return;
      }

      try {
        const month = this.currentMonth + 1; // Backend: 1-12
        const res = await axiosInstance.get("/api/cuadro-mando/calendar", {
          params: { year: this.currentYear, month }
        });

        const payload = res?.data?.data || res?.data || {};
        const porDia = payload?.porDia || res?.data?.porDia || [];
        this.porDia = (porDia || []).map(d => ({
          day: Number(d.day),
          subidos: Number(d.subidos || 0),
          aprobados: Number(d.aprobados || 0),
          rechazados: Number(d.rechazados || 0),
          caducados: Number(d.caducados || 0)
        }));
      } catch (e) {
        console.warn("Error cargando calendar, usando mock:", e);
        this.useMock = true;
        this.porDia = this.generarDatosMock(this.currentYear, this.currentMonth);
      }
    },
    generarDatosMock(year, month0) {
      const last = new Date(year, month0 + 1, 0).getDate();
      const items = [];
      for (let day = 1; day <= last; day++) {
        const dt = new Date(year, month0, day);
        const dow = dt.getDay();
        const factor = dow === 0 || dow === 6 ? 0.6 : 1;
        const subidos = Math.max(0, Math.round((10 + Math.random() * 40) * factor));
        const aprobados = Math.max(0, Math.round(subidos * (0.35 + Math.random() * 0.5)));
        const caducados = Math.max(0, Math.round(subidos * (0.12 + Math.random() * 0.18)));
        const rechazados = Math.max(0, Math.round(subidos * (0.08 + Math.random() * 0.25)));
        items.push({ day, subidos, aprobados, caducados, rechazados });
      }
      return items;
    },
    async mesAnterior() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear -= 1;
      } else {
        this.currentMonth -= 1;
      }
      await this.cargarDatosMes();
      this.dibujarCharts();
      this.syncKpiHeightWithCalendar();
    },
    async mesSiguiente() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear += 1;
      } else {
        this.currentMonth += 1;
      }
      await this.cargarDatosMes();
      this.dibujarCharts();
      this.syncKpiHeightWithCalendar();
    },
    syncKpiHeightWithCalendar() {
      this.$nextTick(() => {
        // En móvil/tablet apilado dejamos altura natural.
        if (window.innerWidth < 992) {
          this.kpiStackHeight = null;
          return;
        }
        const calendarEl = this.$refs.calendarWrapRef;
        if (!calendarEl || typeof calendarEl.offsetHeight !== "number") return;
        this.kpiStackHeight = calendarEl.offsetHeight;
      });
    },

    toYYYYMMDD(dateObj) {
      const yyyy = dateObj.getFullYear();
      const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
      const dd = String(dateObj.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },

    rangoToDates() {
      const to = new Date();
      to.setHours(0, 0, 0, 0);
      const from = new Date(to);
      from.setDate(from.getDate() - (this.rangePreset - 1));
      return { from: this.toYYYYMMDD(from), to: this.toYYYYMMDD(to) };
    },

    async cargarAnalitica() {
      if (this.useMock) {
        this.generarMockAnalitica();
        this.dibujarChartsAnalitica();
        return;
      }

      try {
        const { from, to } = this.rangoToDates();
        const esquemaId = this.esquemaFiltro ? Number(this.esquemaFiltro) : null;

        const params = { from, to };
        if (esquemaId !== null) params.esquemaId = esquemaId;

        const res = await axiosInstance.get("/api/cuadro-mando/analitica", { params });

        const payload = res?.data?.data || res?.data || {};
        this.mapAnalitica(payload);
        this.dibujarChartsAnalitica();
      } catch (e) {
        console.warn("Error cargando analitica, usando mock:", e);
        this.useMock = true;
        this.generarMockAnalitica();
        this.dibujarChartsAnalitica();
      }
    },

    mapAnalitica(payload) {
      const rendimiento = payload?.rendimiento || {};
      const cuellos = payload?.cuellos || {};
      const comportamiento = payload?.comportamiento || {};
      this.propiedadAgrupadoraNombre =
        payload?.propiedadAgrupadoraNombre ||
        rendimiento?.propiedadAgrupadoraNombre ||
        "departamento";

      this.mockPerf = {
        esquemas: (rendimiento?.tiempoMedioAprobacionPorEsquema || []).map(x => ({
          esquema_id: x.esquemaId ?? x.esquema_id ?? x.id ?? 0,
          esquema_nombre: x.esquemaNombre ?? x.esquema_nombre ?? x.nombre ?? `Esquema ${(x.esquemaId ?? x.esquema_id ?? 0) || ""}`,
          avg_seconds: this.round1(x.avgSeconds ?? x.avg_seconds ?? 0),
          count: Number(x.count ?? 0)
        })),
        usuarios: (rendimiento?.tiempoMedioAprobacionPorUsuario || []).map(x => ({
          usuario_id: x.usuarioId ?? x.usuario_id ?? x.id ?? 0,
          usuario_nombre: x.usuarioNombre ?? x.usuario_nombre ?? x.nombre ?? `Usuario ${(x.usuarioId ?? x.usuario_id ?? 0) || ""}`,
          avg_seconds: this.round1(x.avgSeconds ?? x.avg_seconds ?? 0),
          count: Number(x.count ?? 0)
        })),
        deptos: (rendimiento?.tiempoMedioAprobacionPorDepartamento || []).map(x => ({
          departamento_id: x.departamentoId ?? x.departamento_id ?? x.id ?? 0,
          departamento_nombre: x.departamentoNombre ?? x.departamento_nombre ?? x.nombre ?? `Depto ${(x.departamentoId ?? x.departamento_id ?? 0) || ""}`,
          avg_seconds: this.round1(x.avgSeconds ?? x.avg_seconds ?? 0),
          count: Number(x.count ?? 0)
        })),
        series: (rendimiento?.evolucionEnElTiempo || []).map(x => ({
          period: x.periodLabel ?? x.period ?? x.label ?? "",
          count_subidos: Number(x.countSubidos ?? x.count_subidos ?? 0),
          count_aprobados: Number(x.countAprobados ?? x.count_aprobados ?? 0),
          avg_seconds: this.round1(x.avgSecondsAprobacion ?? x.avg_seconds ?? 0)
        }))
      };

      this.mockUsuariosLentos = (cuellos?.usuariosMasLentos || []).map(x => ({
        usuario_id: x.usuarioId ?? x.usuario_id ?? x.id ?? 0,
        usuario_nombre: x.usuarioNombre ?? x.usuario_nombre ?? x.nombre ?? `Usuario ${(x.usuarioId ?? x.usuario_id ?? 0) || ""}`,
        avg_seconds: this.round1(x.avgSeconds ?? x.avg_seconds ?? 0),
        count: Number(x.count ?? 0)
      }));

      this.mockAcumulacionEdad = (cuellos?.acumulacionPorEdadDelPendiente || []).map(x => ({
        label: x.bucketLabel ?? x.bucketLabel ?? x.bucket ?? x.label ?? "",
        value: Number(x.count ?? x.value ?? 0)
      }));

      this.mockRetrasosRecurrentes = (cuellos?.retrasosRecurrentes || []).map(x => ({
        esquema_id: x.esquemaId ?? x.esquema_id ?? x.id ?? 0,
        esquema_nombre: x.esquemaNombre ?? x.esquema_nombre ?? x.nombreEsquema ?? x.nombre ?? `Esquema ${(x.esquemaId ?? x.esquema_id ?? 0) || ""}`,
        usuario_nombre: x.usuarioNombre ?? x.usuario_nombre ?? x.nombreUsuario ?? x.nombre ?? `Usuario ${(x.usuarioId ?? x.usuario_id ?? 0) || ""}`,
        count: Number(x.count ?? 0),
        avg_seconds: this.round1(x.avgSeconds ?? x.avg_seconds ?? 0)
      }));

      const autoVsManual = comportamiento?.autoVsManual || {};
      const autoCount = Number(autoVsManual.autoCount ?? autoVsManual.auto?.count ?? 0);
      const manualCount = Number(autoVsManual.manualCount ?? autoVsManual.manual?.count ?? 0);
      const total = Math.max(1, autoCount + manualCount);
      const pctAuto = Math.round((autoCount / total) * 100);

      this.mockAutoVsManual = {
        auto: { count: autoCount, pct: pctAuto },
        manual: { count: manualCount, pct: 100 - pctAuto }
      };

      this.mockRechazos = (comportamiento?.rechazosPorMotivo || []).map(x => ({
        motivo: x.motivo ?? x.motivoNombre ?? x.label ?? "",
        count: Number(x.count ?? 0)
      }));
    },
    dibujarCharts() {
      if (this.chartSubidos) this.chartSubidos.destroy();
      if (this.chartAprobados) this.chartAprobados.destroy();
      if (this.chartCaducados) this.chartCaducados.destroy();
      if (this.chartRechazados) this.chartRechazados.destroy();

      const labels = (this.porDia || []).map(d => String(d.day));
      const subidosSeries = (this.porDia || []).map(d => d.subidos || 0);
      const aprobadosSeries = (this.porDia || []).map(d => d.aprobados || 0);
      const caducadosSeries = (this.porDia || []).map(d => d.caducados || 0);
      const rechazadosSeries = (this.porDia || []).map(d => d.rechazados || 0);

      const spark = (data, borderColor, backgroundColor) => ({
        type: "line",
        data: {
          labels,
          datasets: [
            {
              data,
              borderColor,
              backgroundColor,
              tension: 0.25,
              pointRadius: 0,
              borderWidth: 2,
              fill: true
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false }, tooltip: { enabled: false } },
          scales: { x: { display: false }, y: { display: false } }
        }
      });

      const ctx1 = this.$refs.chartSubidosRef?.getContext?.("2d");
      const ctx2 = this.$refs.chartAprobadosRef?.getContext?.("2d");
      const ctx3 = this.$refs.chartCaducadosRef?.getContext?.("2d");
      const ctx4 = this.$refs.chartRechazadosRef?.getContext?.("2d");

      if (ctx1) this.chartSubidos = new Chart(ctx1, spark(subidosSeries, "#5e8bff", "rgba(94,139,255,0.15)"));
      if (ctx2) this.chartAprobados = new Chart(ctx2, spark(aprobadosSeries, "#25d366", "rgba(37,211,102,0.15)"));
      if (ctx3) this.chartCaducados = new Chart(ctx3, spark(caducadosSeries, "#f97316", "rgba(249,115,22,0.15)"));
      if (ctx4) this.chartRechazados = new Chart(ctx4, spark(rechazadosSeries, "#a855f7", "rgba(168,85,247,0.15)"));
    }
    ,
    async onChangeRango() {
      // En el futuro: llamar endpoints con filtros.
      await this.cargarAnalitica();
    },
    generarMockAnalitica() {
      // Mock determinista (para que no parpadee demasiado).
      const seed = (this.esquemaFiltro ? Number(this.esquemaFiltro) : 1) * (this.rangePreset || 30);
      const rnd = (n) => {
        // pseudo aleatorio simple reproducible
        const x = Math.sin(n + seed) * 10000;
        return x - Math.floor(x);
      };

      const top = 6;
      const esquemas = Array.from({ length: top }).map((_, i) => {
        const avg = this.round1(500 + rnd(i) * 5000);
        return { esquema_id: i + 1, esquema_nombre: `Esquema ${i + 1}`, avg_seconds: avg, count: Math.round(20 + rnd(i + 10) * 180) };
      });

      const usuarios = Array.from({ length: top }).map((_, i) => {
        const avg = this.round1(600 + rnd(i + 20) * 6000);
        return { usuario_id: i + 1, usuario_nombre: `Usuario ${i + 1}`, avg_seconds: avg, count: Math.round(15 + rnd(i + 30) * 160) };
      });

      const deptos = Array.from({ length: 4 }).map((_, i) => {
        const avg = this.round1(700 + rnd(i + 40) * 5000);
        return { departamento_id: i + 1, departamento_nombre: `Depto ${i + 1}`, avg_seconds: avg, count: Math.round(10 + rnd(i + 50) * 140) };
      });

      // Evolución en el tiempo
      const steps = 8;
      const series = Array.from({ length: steps }).map((_, i) => {
        const period = i + 1;
        const countA = Math.round(20 + rnd(i + 60) * 90);
        const countB = Math.round(10 + rnd(i + 70) * 70);
        const avg = this.round1(800 + rnd(i + 80) * 7000);
        return { period: `T${period}`, count_subidos: countA, count_aprobados: countB, avg_seconds: avg };
      });

      this.mockPerf = {
        esquemas,
        usuarios,
        deptos,
        series
      };

      // Cuellos
      this.mockUsuariosLentos = usuarios.slice().sort((a, b) => b.avg_seconds - a.avg_seconds).slice(0, 5);

      this.mockAcumulacionEdad = [
        { label: "0-1d", value: Math.round(10 + rnd(200) * 30) },
        { label: "1-3d", value: Math.round(10 + rnd(210) * 50) },
        { label: "3-7d", value: Math.round(10 + rnd(220) * 70) },
        { label: "7-30d", value: Math.round(10 + rnd(230) * 80) },
        { label: ">30d", value: Math.round(5 + rnd(240) * 50) }
      ];

      this.mockRetrasosRecurrentes = esquemas.map((s, i) => ({
        esquema_id: s.esquema_id,
        esquema_nombre: s.esquema_nombre,
        usuario_nombre: `Usuario ${((i % top) + 1)}`,
        count: s.count,
        avg_seconds: this.round1(s.avg_seconds * (0.7 + rnd(i + 300) * 0.8))
      }));

      // Comportamiento
      const pctAuto = Math.round(40 + rnd(400) * 45);
      this.mockAutoVsManual = {
        auto: { count: 100, pct: pctAuto },
        manual: { count: 100, pct: 100 - pctAuto }
      };

      this.mockRechazos = Array.from({ length: 5 }).map((_, i) => ({
        motivo: `Motivo ${i + 1}`,
        count: Math.round(10 + rnd(500 + i) * 60)
      })).sort((a, b) => b.count - a.count);
    },
    dibujarChartsAnalitica() {
      // destruir
      if (this.chartPerfEsquemas) this.chartPerfEsquemas.destroy();
      if (this.chartPerfUsuarios) this.chartPerfUsuarios.destroy();
      if (this.chartPerfDeptos) this.chartPerfDeptos.destroy();
      if (this.chartPerfEvolucion) this.chartPerfEvolucion.destroy();
      if (this.chartCuellosUsuarios) this.chartCuellosUsuarios.destroy();
      if (this.chartCuellosEdad) this.chartCuellosEdad.destroy();
      if (this.chartComportAuto) this.chartComportAuto.destroy();
      if (this.chartComportRechazos) this.chartComportRechazos.destroy();

      const mock = this.mockPerf || {};
      const series = mock.series || [];

      const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { enabled: true } },
        scales: { x: { ticks: { maxRotation: 0, autoSkip: false } }, y: { beginAtZero: true } }
      };

      const labelsEsquemas = (mock.esquemas || []).map(x => x.esquema_nombre);
      const dataEsquemas = (mock.esquemas || []).map(x => x.avg_seconds);

      const labelsUsuarios = (mock.usuarios || []).map(x => x.usuario_nombre);
      const dataUsuarios = (mock.usuarios || []).map(x => x.avg_seconds);

      const labelsDeptos = (mock.deptos || []).map(x => x.departamento_nombre);
      const dataDeptos = (mock.deptos || []).map(x => x.avg_seconds);

      // Solo dibujar lo que se ve (v-show = display:none).
      if (this.dashboardTab === "rendimiento") {
        // Esquemas
        const ctxE = this.$refs.chartPerfEsquemasRef?.getContext?.("2d");
        if (ctxE) {
          this.chartPerfEsquemas = new Chart(ctxE, {
            type: "bar",
            data: { labels: labelsEsquemas, datasets: [{ data: dataEsquemas, backgroundColor: "rgba(94,139,255,0.55)" }] },
            options: barOptions
          });
        }

        // Usuarios
        const ctxU = this.$refs.chartPerfUsuariosRef?.getContext?.("2d");
        if (ctxU) {
          const userOptions = {
            ...barOptions,
            scales: {
              ...barOptions.scales,
              x: {
                ...barOptions.scales.x,
                ticks: {
                  autoSkip: false,
                  maxTicksLimit: 6,
                  minRotation: 35,
                  maxRotation: 45,
                  callback: function(value) {
                    const label = this.getLabelForValue(value);
                    if (typeof label !== "string") return label;
                    return label.length > 16 ? `${label.slice(0, 16)}...` : label;
                  }
                }
              }
            }
          };
          this.chartPerfUsuarios = new Chart(ctxU, {
            type: "bar",
            data: { labels: labelsUsuarios, datasets: [{ data: dataUsuarios, backgroundColor: "rgba(37,211,102,0.55)" }] },
            options: userOptions
          });
        }

        // Deptos
        const ctxD = this.$refs.chartPerfDeptosRef?.getContext?.("2d");
        if (ctxD) {
          const deptOptions = {
            ...barOptions,
            scales: {
              ...barOptions.scales,
              x: {
                ...barOptions.scales.x,
                ticks: {
                  autoSkip: false,
                  maxTicksLimit: 6,
                  minRotation: 35,
                  maxRotation: 45,
                  callback: function(value) {
                    const label = this.getLabelForValue(value);
                    if (typeof label !== "string") return label;
                    return label.length > 16 ? `${label.slice(0, 16)}...` : label;
                  }
                }
              }
            }
          };
          this.chartPerfDeptos = new Chart(ctxD, {
            type: "bar",
            data: { labels: labelsDeptos, datasets: [{ data: dataDeptos, backgroundColor: "rgba(255,138,61,0.55)" }] },
            options: deptOptions
          });
        }

        // Evolución (línea count_subidos/count_aprobados)
        const ctxEvo = this.$refs.chartPerfEvolucionRef?.getContext?.("2d");
        if (ctxEvo) {
          this.chartPerfEvolucion = new Chart(ctxEvo, {
            type: "line",
            data: {
              labels: series.map(s => s.period),
              datasets: [
                {
                  label: "Documentos nuevos",
                  data: series.map(s => s.count_subidos),
                  borderColor: "#5e8bff",
                  backgroundColor: "rgba(94,139,255,0.15)",
                  tension: 0.25
                },
                {
                  label: "Documentos aprobados",
                  data: series.map(s => s.count_aprobados),
                  borderColor: "#25d366",
                  backgroundColor: "rgba(37,211,102,0.15)",
                  tension: 0.25
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: { legend: { display: true }, tooltip: { enabled: true } },
              scales: { y: { beginAtZero: true } }
            }
          });
        }
      } else if (this.dashboardTab === "cuellos") {
        // Cuellos: usuarios lentos
        const ctxCL = this.$refs.chartCuellosUsuariosRef?.getContext?.("2d");
        if (ctxCL) {
          this.chartCuellosUsuarios = new Chart(ctxCL, {
            type: "bar",
            data: {
              labels: (this.mockUsuariosLentos || []).map(x => x.usuario_nombre),
              datasets: [{ data: (this.mockUsuariosLentos || []).map(x => x.avg_seconds), backgroundColor: "rgba(249,115,22,0.55)" }]
            },
            options: barOptions
          });
        }

        // Cuellos: acumulación edad
        const ctxCA = this.$refs.chartCuellosEdadRef?.getContext?.("2d");
        if (ctxCA) {
          this.chartCuellosEdad = new Chart(ctxCA, {
            type: "bar",
            data: {
              labels: (this.mockAcumulacionEdad || []).map(x => x.label),
              datasets: [{ data: (this.mockAcumulacionEdad || []).map(x => x.value), backgroundColor: "rgba(13,110,253,0.45)" }]
            },
            options: barOptions
          });
        }
      } else if (this.dashboardTab === "comportamiento") {
        // Comportamiento: auto vs manual (donut)
        const ctxAuto = this.$refs.chartComportAutoRef?.getContext?.("2d");
        if (ctxAuto) {
          this.chartComportAuto = new Chart(ctxAuto, {
            type: "doughnut",
            data: {
              labels: ["Auto", "Manual"],
              datasets: [
                {
                  data: [this.mockAutoVsManual?.auto?.pct || 0, this.mockAutoVsManual?.manual?.pct || 0],
                  backgroundColor: ["rgba(37,211,102,0.75)", "rgba(249,115,22,0.75)"],
                  borderWidth: 0
                }
              ]
            },
            options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: true } } }
          });
        }

        // Comportamiento: rechazos por motivo
        const ctxRech = this.$refs.chartComportRechazosRef?.getContext?.("2d");
        if (ctxRech) {
          this.chartComportRechazos = new Chart(ctxRech, {
            type: "bar",
            data: {
              labels: (this.mockRechazos || []).map(x => x.motivo),
              datasets: [{ data: (this.mockRechazos || []).map(x => x.count), backgroundColor: "rgba(255,138,61,0.55)" }]
            },
            options: barOptions
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.kpi-card {
  border: 1px solid rgba(0, 0, 0, 0.06);
  height: 170px;
  max-height: 170px;
}

.kpi-stack .kpi-card {
  height: 100%;
  max-height: none;
  flex: 1 1 0;
  min-height: 0;
}

.kpi-row {
  height: 170px;
  max-height: 170px;
  overflow: hidden;
}

.kpi-card .card-body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.kpi-chart-area {
  height: 60px;
  max-height: 60px;
  overflow: hidden;
}

.kpi-value {
  font-size: 1.5rem;
  font-weight: 700;
}

.kpi-sparkline {
  height: 60px;
  max-height: 60px;
  width: 100%;
  display: block;
}

.kpi-badge {
  font-size: 0.75rem;
  padding: 4px 10px;
  border-radius: 999px;
  color: #fff;
  font-weight: 600;
}

.kpi-blue {
  background: rgba(94, 139, 255, 0.9);
}
.kpi-orange {
  background: rgba(255, 138, 61, 0.95);
}
.kpi-caducados {
  background: rgba(249, 115, 22, 0.95);
}
.kpi-green {
  background: rgba(34, 197, 94, 0.95);
}

.kpi-purple {
  background: rgba(168, 85, 247, 0.95);
}

.calendar-wrap {
  border: 1px solid rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.calendar-dow {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.calendar-dow:last-child {
  border-right: none;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.calendar-cell {
  min-height: 110px;
  padding: 10px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
}
.calendar-cell:nth-child(7n) {
  border-right: none;
}

.calendar-cell.is-out-month {
  background: #fafafa;
  opacity: 0.6;
}

.calendar-day {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rendimiento-tab canvas,
.cuellos-tab canvas,
.comportamiento-tab canvas {
  height: 260px;
  max-height: 260px;
  width: 100%;
  display: block;
}

.nav-pills .btn.active {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}

.day-number {
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1;
  color: #6b7280; /* text-muted-ish */
}

.day-indicators {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.indicator-pill {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  font-size: 0.75rem;
  padding: 5px 10px;
  border-radius: 8px;
  font-weight: 800;
  color: #ffffff;
  background: #000;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.indicator-blue {
  background: linear-gradient(90deg, #6ea8ff 0%, #0d6efd 100%);
}

.indicator-green {
  background: linear-gradient(90deg, #25d366 0%, #10b981 100%);
}

.indicator-red {
  background: linear-gradient(90deg, #ffa34a 0%, #f97316 100%);
}

.indicator-purple {
  background: linear-gradient(90deg, #a855f7 0%, #7c3aed 100%);
}

.future-indicators {
  margin-top: 8px;
}
</style>

